module.exports = __webpack_public_path__ + "static/media/add-green-pdf.238322e1.svg";